module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[53]174.09d22f7.woff2";